import { Button, notification } from 'antd';
import React from 'react'
import { PhotoButtons, PhotoWrap } from './style';
import { PaperClipOutlined } from '@ant-design/icons';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ASSETS_URL, putArticlePhotoConnect } from '../../services/api';

type PhotoType = {
    alt?: string;
    src: string;
    photoId: string;
    contentId: any;
}

const PhotoSearch = ({alt, contentId, photoId, src}: PhotoType) => {
    
    const queryClient = useQueryClient();
    const [ ntf, contextHolder ] = notification.useNotification();
    const { mutate: mutateConnectPhoto } = useMutation(putArticlePhotoConnect);

    const handleConnectPhoto = () => {
        mutateConnectPhoto({contentId: contentId, photoId: photoId }, {
            onSuccess() {
                queryClient.invalidateQueries(['photos-blog']);
                ntf.success({
                    message: `Success`,
                    description: "Photo is disconnected!",
                    placement: "bottomLeft",
                });
            },
            onError() {
                ntf.error({
                    message: `Error`,
                    description: "Something gonne wrong!",
                    placement: "bottomLeft",
                });
            },
        })
    }
    
    return (
        <PhotoWrap>
            {contextHolder}
            <img src={`${ASSETS_URL}photos/uploads/${src}`} alt={alt} />
            <PhotoButtons>
                <Button type="primary" icon={<PaperClipOutlined />} onClick={() => handleConnectPhoto()}>Connect photo</Button>
            </PhotoButtons>
        </PhotoWrap>
    )
}

export default PhotoSearch;